import type { DecisionEngineDestinationUI } from "./definition";

export const eloquaTriggerUI: DecisionEngineDestinationUI = {
  campaignSetup: "resource",
  resourceName: "email asset",
  channelDescription: "Eloqua (Email trigger)",
  getReferenceString: () => "",
  getResourceUrl: (resource, destinationConfig) => {
    if (resource.id) {
      return `${destinationConfig.baseUrl}/Main.aspx#emails&id=${resource.id}`;
    }
    return "";
  },
  isInactive: () => false,
  isPreviewSupported: true,
  getTemplateResourceType: () => "email-template",
  getResourceType: ({ type }) => (type === "email" ? "email-template" : ""),
  getEmailPreviewMethod: "preview",
  isTestSendSupported: true,
};

export const eloquaCdoUI: DecisionEngineDestinationUI = {
  campaignSetup: "freeform",
  resourceName: "custom data object",
  channelDescription: "Eloqua (Custom data object)",
  getReferenceString: () => "",
  isInactive: () => false,
  isPreviewSupported: true,
  getTemplateResourceType: () => "custom-object",
  getResourceType: ({ type }) => (type === "email" ? "email-template" : ""),
  getEmailPreviewMethod: "preview",
  isTestSendSupported: true,
  showAssociatedTemplate: true,
};
